(() => {
  const charts = {
    kids: [
      ['12\" wheel', 86, 102], ['16\" wheel', 99, 117], ['20\" wheel', 114, 132],
      ['24\" wheel', 130, 150], ['26\" wheel', 146, 160]
    ],
    session: [
      ['R1', 161, 175, 76, 82], ['R2', 174, 188, 82, 88], ['R3', 186, 196, 87, 92]
    ],
    'mtb-core': [
      ['S', 155, 165, 74, 78], ['M', 165, 177, 79, 83],
      ['L', 177, 188, 84, 89], ['XL', 188, 195, 89, 91]
    ],
    'mtb-standard': [
      ['S', 155, 165, 74, 78], ['M', 165, 177, 79, 83], ['ML', 173, 180, 81, 86],
      ['L', 177, 188, 84, 89], ['XL', 188, 195, 89, 91]
    ],
    'mtb-full': [
      ['XS', 145, 155, 69, 73], ['S', 155, 165, 74, 78], ['M', 165, 177, 79, 83],
      ['ML', 173, 180, 81, 86], ['L', 177, 188, 84, 89],
      ['XL', 188, 195, 89, 91], ['2XL', 195, 203, 91, 97]
    ],
    'road-alpha': [
      ['XS (47cm)', 143, 158, 67, 74], ['S (50cm)', 158, 162, 74, 76],
      ['M (52–54cm)', 162, 173, 76, 81], ['ML (56cm)', 173, 179, 81, 84],
      ['L (58cm)', 179, 188, 84, 88], ['XL (60–62cm)', 188, 213, 88, 100]
    ],
    'road-numeric': [
      ['47', 152, 158, 71, 75], ['50', 158, 163, 74, 77], ['52', 163, 168, 76, 79],
      ['54', 168, 174, 78, 82], ['56', 174, 180, 81, 85], ['58', 180, 185, 84, 87],
      ['60', 185, 190, 86, 90], ['62', 190, 195, 89, 92]
    ],
    'gravel-numeric': [
      ['49', 156, 163, 74, 77], ['52', 163, 168, 76, 79], ['54', 168, 174, 78, 82],
      ['56', 174, 180, 81, 85], ['58', 180, 185, 84, 87], ['61', 185, 191, 86, 90]
    ],
    'gravel-alpha': [
      ['XS', 143, 158, 67, 74], ['S (49cm)', 158, 164, 74, 77],
      ['M (52–54cm)', 164, 177, 77, 83], ['ML (56cm)', 177, 188, 83, 88],
      ['L (58cm)', 188, 194, 88, 91], ['XL (61cm)', 194, 203, 91, 95]
    ],
    'gravel-compact': [
      ['S (49cm)', 158, 164, 74, 77], ['M (52–54cm)', 164, 177, 77, 83],
      ['ML (56cm)', 177, 188, 83, 88], ['L (58cm)', 188, 194, 88, 91],
      ['XL (61cm)', 194, 203, 91, 95]
    ]
  };

  const labels = { description: 'Description', specs: 'Specifications', overview: 'Overview', sizing: 'Sizing' };

  const marker = (node) => {
    if (node.nodeType !== 1) return null;
    const text = node.textContent.replace(/\s+/g, ' ').trim().toUpperCase().replace(/[:：]$/, '');
    if (/^(SPECS|SPECIFICATIONS|TECHNICAL SPECIFICATIONS)$/.test(text)) return 'specs';
    if (/^(OVERVIEW|THE WALKTHROUGH|PRODUCT OVERVIEW)$/.test(text)) return 'overview';
    if (/^(SIZING|SIZE GUIDE|FIT & SIZING)$/.test(text)) return 'sizing';
    return null;
  };

  const hasContent = (fragment) => fragment && fragment.textContent.replace(/\s+/g, '').length > 0;

  const sizingPanel = (key) => {
    const rows = charts[key] || charts['mtb-standard'];
    const hasInseam = rows.some((row) => row.length > 3);
    const wrap = document.createElement('div');
    wrap.className = 'biket-trek-sizing';
    wrap.innerHTML = `
      <div class="biket-trek-sizing__intro">
        <p class="biket-trek-sizing__eyebrow">Trek fit guide</p>
        <h3>Find your recommended size</h3>
        <p>Match your height and inseam to the chart below. If you sit between sizes, riding style and body proportions can change the best choice.</p>
      </div>
      <div class="biket-trek-sizing__table-wrap">
        <table class="biket-trek-sizing__table">
          <thead><tr><th>Size</th><th>Rider height</th>${hasInseam ? '<th>Inseam</th>' : ''}</tr></thead>
          <tbody>${rows.map((row) => `<tr><th>${row[0]}</th><td>${row[1]}–${row[2]} cm</td>${hasInseam ? `<td>${row[3]}–${row[4]} cm</td>` : ''}</tr>`).join('')}</tbody>
        </table>
      </div>
      <p class="biket-trek-sizing__note"><strong>Not sure?</strong> Speak to the Biket team for a personal size recommendation before ordering.</p>`;
    return wrap;
  };

  const init = (root, index) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const source = root.querySelector('.biket-trek-tabs__source');
    const tablist = root.querySelector('[role="tablist"]');
    const panels = root.querySelector('.biket-trek-tabs__panels');
    if (!source || !tablist || !panels) return;

    const content = {
      description: document.createDocumentFragment(), specs: document.createDocumentFragment(),
      overview: document.createDocumentFragment(), sizing: document.createDocumentFragment()
    };
    let section = 'description';
    [...source.childNodes].forEach((node) => {
      if (node.nodeType === 1 && (node.matches('.pdl-collapse') || node.querySelector('.pdl-collapse-item'))) {
        section = 'specs';
        content.specs.appendChild(node.cloneNode(true));
        return;
      }
      if (node.nodeType === 1 && (node.id.toLowerCase().includes('sizing') || node.querySelector('[id*="sizingTab"], [id*="SizingComponent"]'))) {
        section = 'sizing';
        return;
      }
      const next = marker(node);
      if (next) { section = next; return; }
      content[section].appendChild(node.cloneNode(true));
    });
    content.sizing = sizingPanel(root.dataset.chart);

    const order = ['description', 'specs', 'overview', 'sizing'];
    const visible = order.filter((name) => name === 'sizing' || hasContent(content[name]));
    visible.forEach((name, position) => {
      const tabId = `biket-trek-tab-${index}-${name}`;
      const panelId = `biket-trek-panel-${index}-${name}`;
      const button = document.createElement('button');
      button.type = 'button';
      button.id = tabId;
      button.className = 'biket-trek-tabs__tab';
      button.role = 'tab';
      button.setAttribute('aria-controls', panelId);
      button.setAttribute('aria-selected', position === 0 ? 'true' : 'false');
      button.tabIndex = position === 0 ? 0 : -1;
      button.textContent = labels[name];

      const panel = document.createElement('div');
      panel.id = panelId;
      panel.className = 'biket-trek-tabs__panel rte';
      panel.role = 'tabpanel';
      panel.setAttribute('aria-labelledby', tabId);
      panel.hidden = position !== 0;
      panel.append(content[name]);
      tablist.append(button);
      panels.append(panel);
    });

    const tabs = [...tablist.querySelectorAll('[role="tab"]')];
    const activate = (button, focus = false) => {
      tabs.forEach((tab) => {
        const selected = tab === button;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !selected;
      });
      if (focus) button.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 :
          (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        activate(tabs[next], true);
      });
    });
    source.remove();
  };

  const positionUnderFloat = () => {
    const wrapper = document.querySelector('.biket-trek-tabs-section');
    const floatScript = document.querySelector('.product-details--form-wrapper script[src*="checkout.float.co.za/widgets/float-details-widget"]');
    const floatBlock = floatScript ? floatScript.closest('.product-form-block') : null;
    if (!wrapper || !floatBlock) return;
    floatBlock.insertAdjacentElement('afterend', wrapper);
  };

  const boot = () => {
    positionUnderFloat();
    document.querySelectorAll('.biket-trek-tabs').forEach(init);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
